import { useFlagConfigValue } from 'hooks/business/system/useFlagConfig';
import { useTransAppProductName } from 'hooks/useTrans';

export const TokopediaAuth = () => {
  const t = useTransAppProductName();
  const { tokopediaContactQrcode } = useFlagConfigValue();

  return (
    <div className="h-96 flex flex-col items-center">
      <p
        className="text-center text-xl"
        dangerouslySetInnerHTML={{ __html: t('quick_chat_tokopedia_qrcode_tips') }}
      />
      <img className="w-56 h-56" src={tokopediaContactQrcode} alt="QRCode" />
    </div>
  );
};
